import * as THREE from 'three'
import Experience from "../Experience"

export default class Kingfisher {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        // Debug
        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder('fish')
        // }

        // Setup
        this.resource = this.resources.items.kingfisherModel

        this.setModel()
        // this.setTextures()
        this.setMaterial()
        this.setAnimation()

    }

    // Check if hotspot is clicked
    addEventListeners() {
        // window.addEventListener('click', (event) => document.querySelectorAll('.point-fish')[0].switchAnimation(), false);
        // document.querySelectorAll('.point-fish')[0].addEventListener('click', this.switchAnimation)
        // document.querySelectorAll('.point-fish')[0].parentElement.querySelector('.close').addEventListener('click', this.switchAnimation)
    }

    setModel() {

        this.model = this.resource.scene
        this.model.children[0].scale.set(0.2, 0.2, 0.2)
        this.model.position.set(-1.5, .615, -5.3)
        this.scene.add(this.model)

        this.originalMesh = this.model.children[0]; // Assuming it's a Mesh
        this.geometry = this.originalMesh.geometry;
        this.material = this.originalMesh.material;

        // Finally add to the scene
        this.scene.add(this.model);

        // for (let i = 0; i < 10; i++) {
        //     this.copy = this.model.clone();
        //     this.copy.position.set(Math.random() * -.75, .5, Math.random() * -4.5);
        //     this.copy.children[0].scale.set(Math.random() * 0.1, Math.random() * 0.1, Math.random() * 0.1)
        //     this.scene.add(this.copy);
        // }
    }

    setMaterial() {
        this.model = this.resource.scene

        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.material.dispose()
                child.material = new THREE.MeshBasicMaterial({ map: child.material.map })
                child.receiveShadow = false // Prevents weird shadows on top of boat
                child.castShadow = true
            }
        })
    }

    setAnimation() {
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer(this.model)

        this.animation.actions = {}

        this.animation.actions.path = this.animation.mixer.clipAction(this.resource.animations[0])

        this.animation.actions.current = this.animation.actions.path
        this.animation.actions.current.play()
        // this.animation.actions.current.time = 50
    }


    update() {

        this.animation.mixer.update(this.time.delta / 1000) // Divide by 1000 because it's in milliseconds
    }
}